import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

export const AccountUserService = {
  async GetUsers() {
    let response = await $axios
      .get($api("get_myAccount"), {
        headers: {
          "Accept-Language": "az",
          Authorization: `Bearer ${getCookie("ColibriToken")}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostUserInfo(payload: any) {
    try {
      const response = await $axios.post($api("edit_userProfie"), payload);
      return response;
    } catch (error: any) {
      throw error;
    }
  },
  async GetTrendYolOtpCode() {
    let response = await $axios
      .get($api("get_TrendyolOtpCode"), {
        headers: {
          "Accept-Language": "az",
          Authorization: `Bearer ${getCookie("ColibriToken")}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
